<template>
    <div>
        <p class="h5 my-4">{{group.name}}</p>

        <app-property v-for="property of group.properties" :key="property.id" :property="property"/>

    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from "vue-property-decorator";
    import AppProperty from "@/components/questionnaire/AppProperty.vue";
    import {Group} from "@/entities/questionaire/Group";

    @Component({
        components: {
            AppProperty: AppProperty,
        },
    })
    export default class AppGroup extends Vue{
        @Prop()
        group?: Group;
    }
</script>

<style scoped>
</style>
